import { ControllerRenderProps } from "react-hook-form";
import MultipleSelector, { Option } from "@/components/ui/multiple-selector";
import { LanguageResponse } from "@/generated-api";
import { useGetLanguages } from "@/tanstack-hooks";
import Spinner from "@/components/Spinner";

export default function LanguageSelector({
  formField,
  placeholder = "Search",
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formField: ControllerRenderProps<any>;
  placeholder?: string;
}) {
  const languagesQuery = useGetLanguages();

  if (languagesQuery.isLoading) {
    return <Spinner />;
  }

  const languages = languagesQuery.data as LanguageResponse[];

  const mappedOptions: Option[] = languages.map(
    (language: LanguageResponse) => ({
      label: language.name,
      value: language.name,
      id: language.id,
    })
  );

  return (
    <MultipleSelector
      {...formField}
      options={mappedOptions}
      maxSelected={5}
      className="w-full"
      placeholder={placeholder}
      hidePlaceholderWhenSelected={true}
      loadingIndicator={
        <p className="py-2 text-center text-lg leading-10 text-muted-foreground">
          searching...
        </p>
      }
      emptyIndicator={
        <p className="text-center leading-10 text-gray-600 dark:text-gray-400">
          No results, type to search.
        </p>
      }
    />
  );
}
